module.exports = __webpack_public_path__ + "static/media/Pista_Pestana.e8eead59.png";